import React, { useEffect, useState } from "react";
import { Input, PrimaryButton } from "best-common-react";

function TicketmasterSearchParams(params) {
  const [searchValue, setSearchValue] = useState("");

  const search = accountId => {
    params.compTixApi.searchTickets(params.dsn, params.homeTeamId, params.gamePk, accountId).then(res => {
      params.onSearch(res);
    });
  };

  return (
    <div>
      <div className="d-flex flex-row my-2">
        <div className="d-flex flex-column col-6">
          <Input value={searchValue} onChange={e => setSearchValue(e.target.value)} />
        </div>
        <PrimaryButton disabled={searchValue.trim() === ""} onClick={() => search(searchValue)}>
          Search Account
        </PrimaryButton>
      </div>
    </div>
  );
}

export default TicketmasterSearchParams;
